import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../helpers/helpers'

Vue.use(Vuex)

const state = {
  currentUser: {},
  userMeta: {}
}

const mutations = {
  SET_USER (state, user) {
    if (user) {
      state.currentUser = user
      db.ref('users/' + user.uid).once('value').then(function (s) {
        state.userMeta = s.val()
      }, function (error) {
        console.error(error)
      })
    }
  }
}

const actions = {
  setUser ({commit}, user) {
    commit('SET_USER', user)
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js